import angular from 'angular';
import UIRouter from 'angular-ui-router';

import createStub from '../olr-common/createStub';
import './styles/index.scss';
import template from './index.html';
import AccountController from './AccountController';
import LeadService, {LeadServiceStub} from './LeadService';

let namespace = angular.module('olr-mainfe-account', [
  UIRouter,
  'olr-common'
]);

createStub(namespace, LeadServiceStub);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.account', {
    url: '/account',
    controller: AccountController,
    controllerAs: 'accountCtrl',
    template: template
  });
});

namespace.controller('AccountController', AccountController);
namespace.service('LeadService', LeadService);

export default namespace.name;



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-account/index.js
 **/